const guiColors = {
    'motion-primary': '#078e70', // teal green
    'motion-primary-transparent': '#078e70bf', // semi-transparent teal green
    'motion-tertiary': '#26cfaa', // light green

    'looks-secondary': '#078e70', // teal green
    'looks-transparent': '#078e7059', // more transparent teal green
    'looks-light-transparent': '#078e7026', // very transparent teal green
    'looks-secondary-dark': 'hsla(168, 75%, 40%, 1)', // darker teal green

    'extensions-primary': 'hsla(168, 60%, 70%, 1)', // light green
    'extensions-tertiary': 'hsla(230, 55%, 55%, 1)', // blue
    'extensions-transparent': 'hsla(230, 55%, 55%, 0.35)', // semi-transparent blue
    'extensions-light': 'hsla(255, 65%, 50%, 1)', // indigo

    'drop-highlight': '#26cfaa', // light green

    'menu-bar-background-image':
        'linear-gradient(90deg, rgba(7, 142, 112, 0.75) 0%, rgba(38, 207, 170, 0.75) 16.67%, ' +
        'rgba(152, 233, 193, 0.75) 33.33%, rgba(251, 254, 252, 0.75) 50%, ' +
        'rgba(123, 173, 226, 0.75) 66.67%, rgba(80, 73, 203, 0.75) 83.33%, ' +
        'rgba(63, 32, 130, 0.75) 100%)' // new gradient
};

const blockColors = {
    checkboxActiveBackground: '#078e70', // teal green
    checkboxActiveBorder: '#26cfaa' // light green
};

export {
    guiColors,
    blockColors
};
